module.exports = __webpack_public_path__ + "img/image153.126d9487.jpg";